import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Ebooks from "@/pages/Ebooks";
import AITools from "@/pages/AITools";
import Affiliate from "@/pages/Affiliate";
import Shorts from "@/pages/Shorts";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import LegalPage from "@/pages/Legal";
import Admin from "@/pages/Admin";
import "@/App.css";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/ebooks" element={<Ebooks />} />
                        <Route path="/ai-tools" element={<AITools />} />
                        <Route path="/affiliate" element={<Affiliate />} />
                        <Route path="/shorts" element={<Shorts />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/faqs" element={<FAQ />} />
                        <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
                        <Route path="/affiliate-disclosure" element={<LegalPage pageKey="affiliate-disclosure" />} />
                        <Route path="/disclaimer" element={<LegalPage pageKey="disclaimer" />} />
                        <Route path="/terms" element={<LegalPage pageKey="terms" />} />
                        <Route path="/admin" element={<Admin />} />
                        {/* /dropshipping redirects to /affiliate for any legacy links */}
                        <Route path="/dropshipping" element={<Affiliate />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}

export default App;
